import type { SVGProps } from "react";

// HTC VIVE 플랫폼 로고 (Figma/브랜드 마크). currentColor 라 호출처에서 색 지정.
// 게임 플랫폼 아이콘 맵(GameCard / GameMetadataSection · 웹/웹뷰)에서 `vive` 플랫폼용으로 사용.
// SVG props(onClick 등) 를 forward — 플랫폼 아이콘 클릭 시 스토어 링크 열기 등 다른 아이콘과 동일 동작.
const ViveIcon = ({ className, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 98 98"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden
    {...props}
  >
    <path
      d="M62.028 70.976c-4.106 1.287-8.49 2.004-13.02 2.004-4.528 0-8.916-.717-13.018-2.004-4.811-1.575-7.785-6.442-6.795-11.452 1.84-9.163 6.51-17.181 13.163-23.338 3.82-3.579 9.625-3.579 13.445 0 6.51 6.014 11.18 14.172 13.163 23.338.85 5.012-1.98 10.022-6.938 11.452ZM85.38 66.395 57.924 18.435c-.849-1.576-2.407-2.435-4.105-2.435h-9.481c-1.698 0-3.256.859-4.106 2.435L12.637 66.395c-.849 1.576-.849 3.437 0 4.867l4.81 8.303c.85 1.576 2.408 2.435 4.106 2.435h54.77c1.699 0 3.257-.859 4.106-2.435l4.811-8.303c.99-1.575.99-3.436.14-4.867Z"
      fill="currentColor"
    />
  </svg>
);

export default ViveIcon;
